import { DiscordSDK } from '@discord/embedded-app-sdk';

// Store the Discord SDK instance outside of Redux since it's not serializable
let sdkInstance: DiscordSDK | null = null;

// Helper function to initialize Discord SDK
export const initializeDiscordSDK = async (clientId: string): Promise<void> => {
  console.log('🔄 initializeDiscordSDK called with clientId:', clientId);
  console.log('🔄 clientId type:', typeof clientId);
  console.log('🔄 clientId length:', clientId?.length);

  if (!clientId) {
    console.error('❌ Discord client ID not configured');
    throw new Error('Discord client ID not configured');
  }

  console.log('🔄 Creating DiscordSDK instance with clientId:', clientId);

  const discordSdk = new DiscordSDK(clientId);

  console.log('🔄 Calling discordSdk.ready()...');
  await discordSdk.ready();

  sdkInstance = discordSdk;
  console.log('✅ Discord SDK ready');
};

// Export getter for Discord SDK instance
export const getDiscordSDK = (): DiscordSDK | null => {
  return sdkInstance;
};

// Helper function to open external links (required for sandboxed iframe)
export const openExternalLink = async (url: string): Promise<void> => {
  const sdk = getDiscordSDK();
  if (!sdk) {
    console.error('Discord SDK not initialized');
    return;
  }

  try {
    await sdk.commands.openExternalLink({ url });
  } catch (error) {
    console.error('Failed to open external link:', error);
  }
};


